import Vue from 'vue';
import dayjs from 'dayjs';

export default function () {
  Vue.component('donation', {
    props: {
      isPopupVisible: Boolean
    },
    mounted() {
      let lastOpened = localStorage.getItem('lastOpened');
      let hours = dayjs().diff(dayjs(lastOpened), 'hours');

      localStorage.setItem('lastOpened', dayjs());

      // Do NOT show the pop-up if 1 hour is not passed
      if (hours < 1) {
        return false;
      }

      this.loadPopup();
    },

    methods: {
      close() {
        this.$emit('change-popup-visible', false);
      },

      open() {
        this.isPopupVisible = true;
      },

      loadPopup() {
        console.log('something');
        const showDelay = 0;
        // const hideDelay = 0;

        setTimeout(() => {
          this.$emit('change-popup-visible', true);
        }, showDelay);

        // if (hideDelay) {
        //   setTimeout(() => {
        //     this.$emit('change-popup-visible', false);
        //   }, hideDelay);
        // }
      }
    }
  });
}
